<template>
  <svg
    width="10"
    height="14"
    viewBox="0 0 10 14"
    fill="none"
    class="fill-gray-500"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.33329 13.6666C7.24395 13.6666 9.99996 8.24397 9.99996 4.99998C9.99996 2.42265 7.91062 0.333313 5.33329 0.333313C2.75596 0.333313 0.666626 2.42265 0.666626 4.99998C0.666626 8.24397 3.42263 13.6666 5.33329 13.6666ZM5.33329 3.33335C6.25377 3.33335 6.99996 4.07955 6.99996 5.00002C6.99996 5.9205 6.25377 6.66669 5.33329 6.66669C4.41282 6.66669 3.66663 5.9205 3.66663 5.00002C3.66663 4.07955 4.41282 3.33335 5.33329 3.33335Z"
    />
  </svg>
</template>
